import React from 'react'

interface UploadProgressProps {
  progressPercent: number
  tight?: boolean
}

export function UploadProgress({ progressPercent, tight }: UploadProgressProps) {
  const percentage = Math.round(progressPercent)
  const text = tight ? `${percentage}%` : `${percentage}% uploaded`

  return (
    <div className={`flex flex-row gap-2 items-center rounded text-sm ${tight ? '' : 'p-2 border border-secondary'}`}>
      <span>{text}</span>
      <div className="w-24 bg-tertiary rounded-full h-1">
        <div className="bg-success-inverse h-1 rounded-full" style={{ width: `${progressPercent}%` }} />
      </div>
    </div>
  )
}
